import React from "react";
import "./styles/bootstrap.min.css";
import Navbar from "./components/Navbar";
import HeroMain from "./components/HeroMain";
import AboutUs from "./components/AboutUs";
import OurTeam from "./components/OurTeam";
import Events from "./components/Events";
import ContactUs from "./components/ContactUs";

export default function App() {
  return (
    <div>
      <Navbar />
      <HeroMain />
      <AboutUs />
      <OurTeam />
      <Events />
      <ContactUs />
    </div>
  );
}
